import styled from 'styled-components';
import { Input, Select, Button, DatePicker } from 'antd';

export const StyledSection = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledSectionHeader = styled.div`
  font-weight: 600;
  font-size: ${({ theme }) => theme.font.size.small};
  margin-top: ${({ theme }) => theme.spacing.space_5};
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledFieldRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledRemoveButton = styled(Button)`
  align-self: center;
`;

export const StyledAddButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;
